/* Built In Imports */

/* External Imports */
import { Box } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import TopKolam from '@components/Headings/TopKolam';
import { useMediaQuery } from 'react-responsive';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/**
 * Renders the ImageBannerAd Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.width
 * @param sectionContent.height
 * @param sectionContent.my
 * @param sectionContent.display
 * @param sectionContent.maxW
 * @returns {ReactElement} ImageBannerAd component
 */
const WhyPartnerUs = ({
    section, region, language
}) => {
    // const isMobile = useMediaQuery({ maxWidth: 767 });
    return (
        <Box
            width={"100%"}
            // height={{ base: "677px", sm: "677px", lg: "515px" }}
            padding={{ base: "60px 0px", sm: "60px 0px", lg: "80px 0" }}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
        >
            <Box display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
            >

                <Box
                    position={"relative"}
                >
                    <Box
                        fontSize={{ base: "30px", sm: "30px", lg: "30px" }}
                        fontWeight={"semibold"}
                        color={"#000000"}
                        width={{ base: "280px", sm: "280px", lg: "100%" }}
                        textAlign={"center"}
                        lineHeight={"40px"}
                    >
                        {section?.sectionContent[0]?.titleText}
                    </Box>
                    <Box position={"absolute"} top={{ base: "65px", sm: "65px", lg: "30px" }} left={{ base: "55px", sm: "55px", lg: "70px" }}>
                        <TopKolam sectionContent={section?.sectionContent[1]} />
                    </Box>
                </Box>
                <Box
                    marginTop={{ sm: "75px", base: "75px", lg: "80px" }}
                    display={"flex"}
                    flexDirection={{ sm: "column", base: "column", lg: "row" }}
                    alignItems={'self-start'}
                    width={"100%"}
                >
                    {section.sectionContent[2]?.cards?.map((section, index) => {
                        return (
                        <Box
                            display="flex"
                            flexDirection="column"
                            key={nanoid()}
                            alignItems={"center"}
                            justifyContent={"center"}
                            width={"266px"}
                            marginRight={{ base: "0px", sm: "0px", lg: "40px" }}
                            marginBottom={{ base: "36px", sm: "36px", lg: "0px" }}
                        >
                            <Box
                            mb={{ base: 4, md: 6 }}
                            >
                            <LazyLoadImageComponent
                                src={section.thumbnail?.url}
                                title={section.thumbnail?.title}
                                alt={section.thumbnail?.alt}
                                maxWidth={{ base: 190, md: 270 }}
                            />
                            </Box>
                            <Box
                                as="h2"
                                fontFamily="FedraSansStd-A-medium"
                                fontSize={'20px'}
                                mb={4}
                                textAlign={"center"}
                                maxW={'225px'}
                            >
                            {section.title}
                            </Box>
                            <Box
                                as="p"
                                fontFamily="FedraSansStd-book"
                                fontSize="16px"
                                color="#28231e"
                            >
                            <StructuredTextParser
                                str={render(section.description)}
                                region={region}
                                language={language}
                                textAlign="center"
                                mt="0"
                            />
                            </Box>
                        </Box>
                        );
                    })}
                </Box>

            </Box>
        </Box >
    );
};

export default WhyPartnerUs;
